import axios from 'axios';
import CryptoJS from 'crypto-js/crypto-js';
axios.defaults.withCredentials = true;
var _this = this;

function add0(m) {
	return m < 10 ? '0' + m : m
}

function switchTime(val) {
	//val是整数，否则要parseInt转换
	var time = new Date(parseInt(val));
	var y = time.getFullYear();
	var m = time.getMonth() + 1;
	var d = time.getDate();
	var h = time.getHours();
	var mm = time.getMinutes();
	var s = time.getSeconds();
	return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
}

function switchTime2(val) {
	//val是整数，否则要parseInt转换
	var time = new Date(parseInt(val));
	var y = time.getFullYear();
	var m = time.getMonth() + 1;
	var d = time.getDate();
	var h = time.getHours();
	var mm = time.getMinutes();
	var s = time.getSeconds();
	return y + '-' + add0(m) + '-' + add0(d);
}

function showLoadHide() {
	setTimeout(function() {
		if (document.getElementsByClassName("wx_loading").length > 0) {
			var load = document.getElementsByClassName("wx_loading")[0].style.display;
			if (load != 'none') {
				document.getElementsByClassName("ui_hide_loading")[0].style.display = "";
			}
		}
	}, 1000);
}

//http加密判断
function httpchange() {
	if (window.location.hostname.indexOf('gz') != -1) {
		return true //true为线上
	} else {
		return false //true为线上
	}
}

var numbers = 0;
//获取请求地址
function getBasePath(resultUrl, type) {
	var baseHref = window.location.protocol + "//" + window.location.hostname + (window.location.port == '' ? '' : ':' +
		window.location.port);
	//判断是 开发环境 还是 线上环境
	var basePath = ''
	if (window.location.hostname.indexOf('gz') != -1) {
		basePath = type == 'Gzal' ? 'https://gz.aliyizhan.com' : 'https://aliyizhan.com'; //线上
	} else {
		if (resultUrl.indexOf('shopping/V2') != -1 || resultUrl.indexOf('cloudAlbumPayment') != -1) {
			basePath = 'https://aliyizhan.com'
		} else {
			// basePath = '/'+type; //本地
			basePath = type == 'Gzal' ? 'https://gz.aliyizhan.com' : 'https://aliyizhan.com';
		}
	}

	console.log("**********************当前环境日志***************************" + process.env.NODE_ENV)
	if (process.env.NODE_ENV === 'development') {

		if (resultUrl.indexOf('shopping/V2') != -1 || resultUrl.indexOf('cloudAlbumPayment') != -1 ||
			resultUrl.indexOf('refund') != -1 || resultUrl.indexOf('shopping/manualAddDeliver') != -1 || resultUrl
			.indexOf(
				"shopping/updateDeliverExpsnV2") != -1 || resultUrl.indexOf('display/getBusinessUsers') != -1 ||
			resultUrl.indexOf("user/getCloudArchivesAccounts") != -1 || resultUrl.indexOf(
				'user/updateCloudArchivesAccountsState') != -1 || resultUrl.indexOf("shopping/addOrdersRemark") != -1) {
			basePath = window.location.protocol + "//" + 'aliyizhan.com'
			// basePath = 'http://dev.aliyizhan.com:8080'
		} else {
			basePath = window.location.protocol + "//" + 'gz.aliyizhan.com';
			// basePath = 'http://dev.aliyizhan.com';
		}
	}
	if (resultUrl.indexOf('display/getBindUsers') != -1) {
		basePath = window.location.protocol + "//" + 'gz.aliyizhan.com'
	}

	if (resultUrl.indexOf("shopping/queryDeliverV2") != -1 || resultUrl.indexOf("shopping/V2/manualReceipt.action") != -
		1 || resultUrl.indexOf("/shopping/queryRefundDeliver") != -1) {
		basePath = window.location.protocol + "//aliyizhan.com" + resultUrl
	} else {
		basePath += resultUrl;
	}
	//线上 http://gz.aliyizhan.com + 接口地址   本地 /api + 接口地址
	//线上 ?marketCode=gz"  本地 ""
	var url = location.search,
		flag = true; //获取url中"?"符后的字串

	//判断是都包含?  如果包含就是线上  不包含就是本地
	if (url.indexOf("?") != -1 && resultUrl != '/login/auth' && resultUrl != '/login/getInfo' && resultUrl !=
		'/yunLogin') {
		//拿到?后面的字符串
		var str = url.substr(1);
		//从&出切割返回一个数组
		var strs = str.split("&");
		for (var i = 0; i < strs.length; i++) {
			//拿到包含marketCode的字符串
			if (strs[i].split("=")[0] == "marketCode") {
				//判断请求的接口是否包含?
				if (resultUrl.indexOf("?") != -1 && (basePath.indexOf('shopping/V2') == -1 || basePath.indexOf(
						'cloudAlbumPayment') == -1)) {
					//如果已经带有? 例如get请求  则使用& 地区进行加密
					basePath += '&marketCode=' + unescape(strs[i].split("=")[1]);
				} else {
					//如果没有则直接拼接? 地区进行加密
					basePath += '?marketCode=' + unescape(strs[i].split("=")[1]);
				}
				return {
					success: true,
					basePath: basePath,
				};
			}
		}
	}
	//如果是线上并且不包含?marketCode  那么将提示
	if (resultUrl != '/login/auth' && resultUrl != '/login/getInfo' && resultUrl != '/yunLogin' && (basePath.indexOf(
			'shopping/V2') == -1 || basePath.indexOf('cloudAlbumPayment') == -1)) {
		//本地开发环境则自动拼接marketCode

		//判断请求的接口是否包含?
		if (resultUrl.indexOf("?") != -1) {
			//如果已经带有? 例如get请求  则使用&
			basePath += '&marketCode=gz';
		} else {
			//如果没有则直接拼接?
			basePath += '?marketCode=gz';
		}
		return {
			success: true,
			basePath: basePath,
		};
	}
	return {
		success: true,
		basePath: basePath,
	}
}
//AES解密
function decryption(data) {
	var keyStr = 'wxtdefgabcdawn12';
	var key = CryptoJS.enc.Utf8.parse(keyStr);
	var decrypt = CryptoJS.AES.decrypt(data, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return JSON.parse(CryptoJS.enc.Utf8.stringify(decrypt).toString());
}
//AES加密
function encryption(data) {
	var keyStr = 'wxtdefgabcdawn12';
	var key = CryptoJS.enc.Utf8.parse(keyStr);
	//  var iv = CryptoJS.enc.Utf8.parse("1234567890123456");   //  向量
	var srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
	var encrypted = CryptoJS.AES.encrypt(srcs, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return encrypted.toString();
}


export default {
	httpchange,
	decryption,
	switchTime,
	switchTime2,
	IIapipostII: function(htype, hostv, url, params, dEn, fns, fnf, entype, type, type2) {
		console.log(document.cookie.length, window.location.protocol, htype, hostv, url, params, dEn, fns)
		var baseHref = '';
		var basePath = ''

		baseHref = window.location.protocol + "//" + window.location.host + (window.location.port == '' ? '' : ':' +
			window.location.port)
		basePath = process.env.NODE_ENV === 'production' ? baseHref : hostv;

		var config = {}
		if (htype == 'json') {
			config = {
				headers: {
					'Content-Type': 'application/json;charset=UTF-8'
				},
				timeout: 120000, //设置请求超时时间20s
			}
		} else {
			config = {
				headers: {
					'Content-Type': 'application/wxt;charset=UTF-8'
				},
				timeout: 120000 //设置请求超时时间20s
			}
		}
		var p = getBasePath(url, hostv);
		if (!p.success) {
			return false
		}
		var postman = ''
		if (params) {
			postman = axios({
				url: p.basePath,
				method: 'post',
				data: dEn == 'NoEn' ? params : encryption(params),
				headers: config.headers
			})
		} else {
			postman = axios({
				url: p.basePath,
				method: 'post',
				data: '',
				headers: config.headers
			})
		}
		postman.then((res) => {
				console.log(res, 55555)
				numbers = 0;
				// entype ='no'
				if (typeof res == "object" && res.data.code === '502') {
					layer.open({
						content: res.data.msg,
						time: 30
					});
					return
				}
				if (fns == 1) {
					let data = decryption(res.data);
					if (data.success) {
						layer.open({
							content: '添加成功',
							time: 30,
							btn: ["确定"],
							yes: function(index) {
								layer.close(index);
							}
						});
						// console.log(data)
						fns(data);
						return
					} else {
						layer.open({
							content: data.msg,
							time: 30,
							btn: ["确定"],
							yes: function(index) {
								layer.close(index);
							}
						});
						return
					}
				}
				let data = typeof res.data == "object" ? res.data : decryption(res.data);
				console.log(data, 789789)
				//      console.log(data)
				if (res.status == 200 && url == '/login/auth') {
					fns(data)
					return
				} else if (res.status == 200 && url == '/login/getInfo') {
					fns(data)
					return
				}
				console.log(data, 789)
				if (data.success) {
					fns(data);
					return
				} else if (data.code == "U1008") {
					// console.log(data)
					if (url.indexOf("marketManager/") != -1) {

					} else {
						var message = "服务器繁忙,请稍后重试!";
						var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
						if (reg.test(data.msg)) {
							message = data.msg
						}
						layer.open({
							content: message,
							time: 30,
							btn: ["确定"],
							yes: function(index) {
								localStorage.removeItem('userId')
								layer.close(index);
							}
						});
					}
				} else {
					// var message = "服务器繁忙,请稍后重试!";
					// var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
					// if (reg.test(data.msg)) {
					//   message = data.msg
					// }
					fns(data);
					layer.open({
						content: data.msg,
						time: 30,
						btn: ["确定"],
						yes: function(index) {
							layer.close(index);
						}
					});
				}
			})
			.catch(error => {
				if (fnf) {
					// fnf(error);
				} else {
					console.log(error)
					//超时之后在这里捕抓错误信息.
					if (error.response) {
						layer.open({
							content: "服务器被小丁丁玩坏了，点击刷新页面",
							time: 30,
							end: function() {

								numbers = 0;
								// window.location.reload();
							}
						});
					} else if (error.request) {
						if (error.request.readyState == 4 && error.request.status == 0) {

							numbers = numbers + 1;
							if (numbers <= 4) {
								postResponse(url, params, fns, fnf);

								//					window.location.reload();
							} else {
								layer.open({
									content: "加载超时,点击刷新",
									time: 30,
									btn: ["确定"],
									yes: function(index) {

										layer.close(index);
										numbers = 0;

										postResponse(url, params, fns, fnf);
									}
								});

							}
						}
					} else if (url != '/login/auth' &&
						(p.basePath.indexOf('shopping/V2') == -1 &&
							p.basePath.indexOf('cloudAlbumPayment') == -1 &&
							p.basePath.indexOf('getOrderBySN') == -1 &&
							p.basePath.indexOf('/refund/updateRefundShip') == -1 &&
							p.basePath.indexOf('/refund/getRefundDetails') == -1 &&
							p.basePath.indexOf('/refund/autoUpdateRefundProcessMode') == -1 &&
							p.basePath.indexOf('/refund/serviceUndoRefund') == -1 &&
							p.basePath.indexOf('/refund/serviceReRefund') == -1 &&

							p.basePath.indexOf('/refund/getExpress') == -1 &&
							p.basePath.indexOf("/refund/undoRefundService") == -1

						)) {
						layer.open({
							content: "版本更新中,点击更新页面",
							time: 30,
							end: function() {
								numbers = 0;
								// window.location.reload();
							}
						});
					}

				}
			});
	},
	// 转换日期格式
	handleDateStyle: function(time) {
		var date = new Date(time)
		var year = date.getFullYear()
		var month = date.getMonth() + 1
		var day = date.getDate()
		// var hour = date.getHours()
		// var min = date.getMinutes()
		// var send = date.getSeconds()
		month = month > 9 ? month : '0' + month
		day = day > 9 ? day : '0' + day
		// hour = hour > 9 ? hour : '0' + hour
		// min = min > 9 ? min : '0' + min
		// send = send > 9 ? send : '0' + send
		return `${year}-${month}-${day}`
		// return `${year}-${month}-${day} ${hour}:${min}:${send}`
	},
	// 转换日期时间格式
	handleEveryDateStyle: function(time) {
		var date = new Date(time)
		var year = date.getFullYear()
		var month = date.getMonth() + 1
		var day = date.getDate()
		var hour = date.getHours()
		var min = date.getMinutes()
		var send = date.getSeconds()
		month = month > 9 ? month : '0' + month
		day = day > 9 ? day : '0' + day
		hour = hour > 9 ? hour : '0' + hour
		min = min > 9 ? min : '0' + min
		send = send > 9 ? send : '0' + send
		// return `${year}-${month}-${day}`
		return `${year}-${month}-${day} ${hour}:${min}:${send}`
	},
	IIapigetII: function(hostv, url, fnc, fnf, entype) {
		var axiosv = axios.create({
			withCredentials: true
		})
		axiosv.interceptors.request.use(config => {
			if (config.method === 'get') {
				//  给data赋值以绕过if判断
				config.data = true
			}
			config.headers['content-type'] = 'application/json;charset=UTF-8'
			config.headers['Accept'] = '*/*'
			config.headers['Cache-Control'] = 'no-cache'
			config.headers['Pragma'] = 'no-cache'
			return config
		}, err => Promise.reject(err)) //
		if (url.indexOf('shopping/V2') != -1 || url.indexOf('cloudAlbumPayment') != -1) {
			var baseHref = 'aliyizhan.com'
		} else if (url.indexOf('display/getBindUsers') != -1) {
			var baseHref = 'gz.aliyizhan.com'
		} else {
			var baseHref = window.location.protocol + "//" + window.location.host + (window.location.port == '' ?
				'' :
				':' +
				window.location.port);
		}
		console.log(hostv, 1111)
		var basePath = process.env.NODE_ENV === 'production' ? baseHref : hostv;
		var p = getBasePath(url, hostv);
		if (!p.success) {
			return false
		}
		axiosv({
				url: p.basePath,
				method: 'get',
			}).then((res) => {
				// debugger
				if (typeof res == "object" && res.data.code === '502') {
					layer.open({
						content: res.msg || res.data.msg,
						time: 30
					});
					return
				}
				var data = entype == 'NoEn' ? res.data : decryption(res.data);
				localStorage.setItem('data', data.data.allRegister)
				if (!data.success) showLoadHide();
				if (res.status == 200) { //针对于接口'/yunLogin'
					fnc(entype == 'NoEn' ? res : data);

				}


				if (data.success) {

					// fnc(data)

					// var c = $('#app')
					// c.html('')
					console.log(data, 789)
					fnc(data);

				} else if (data.code == "U1008") {
					if (url.indexOf("marketManager/") != -1) {
						window.location.href = window.location.href.substring(0, window.location.href.indexOf(
								"#/")) +
							"#/manager/managerLogin";
						// window.location.reload();
					} else {
						if (fnf) {
							fnf(data);
						} else {
							var message = "服务器繁忙,请稍后重试!";
							var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
							if (reg.test(data.msg)) {
								message = data.msg
							}
							layer.open({
								content: message,
								time: 30,
								btn: ["确定"],
								yes: function(index) {
									localStorage.removeItem('userId')
									layer.close(index);
								}
							});
						}

					}
				} else {
					if (fnf) {
						fnf(data);
					} else {
						var message = "服务器繁忙,请稍后重试!";
						var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
						if (reg.test(data.msg)) {
							message = data.msg
						}
						layer.open({
							content: message,
							time: 30,
							end: function() {
								// window.location.reload();
							}
						});
					}

				}
			})
			.catch(error => {
				console.log(error, 7777)
				//超时之后在这里捕抓错误信息.
				if (error.response) {
					layer.open({
						content: "服务器被小丁丁玩坏了，点击刷新页面",
						time: 30,
						end: function() {

							// window.location.reload();
						}
					});
				} else if (error.request) {
					if (error.request.readyState == 4 && error.request.status == 0) {
						//我在这里重新请求
						layer.open({
							content: "连接超时,请检查网络是否正常",
							btn: ["确定"],
							yes: function(index) {
								layer.close(index);
								// window.location.reload();
							}
						});
					}
				} else if (url != '/login/auth' && url != '/yunLogin' &&
					(p.basePath.indexOf('shopping/V2') == -1 &&
						p.basePath.indexOf('cloudAlbumPayment') == -1) &&
					p.basePath.indexOf('/refund/updateRefundShip') == -1 &&
					p.basePath.indexOf('/refund/autoUpdateRefundProcessMode') == -1 &&
					p.basePath.indexOf('/refund/serviceUndoRefund') == -1 &&
					p.basePath.indexOf('/refund/serviceReRefund') == -1 &&
					p.basePath.indexOf('/refund/getRefundDetails') == -1 &&
					p.basePath.indexOf('/refund/getExpress') == -1 &&
					p.basePath.indexOf("/refund/undoRefundService") == -1 &&
					p.basePath.indexOf("/refund/getRefundProcess") == -1

				) {
					layer.open({
						content: "版本更新中,点击更新页面",
						time: 30,
						end: function() {
							numbers = 0;
							// window.location.reload();
						}
					});
				}
			});
	}
}


// WEBPACK FOOTER //
// ./src/components/js/axios.js